export default __webpack_public_path__ + "d2a840d1c1f6ed572c74e40cca2816af.svg";